export default __webpack_public_path__ + "static/media/manos.1e80f1cc.png";